import GeneralCostCenters from '../General/CostCenters/GeneralCostCenters';

export default GeneralCostCenters;
